import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const Education = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 400;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  const diplomas = [{
    title: 'Магистр психологии',
    institution: 'Национальный исследовательский университет «Высшая школа экономики»',
    year: '2021',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iVQuZ4Wqm58Ya3KA6bZqDZ/%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA_%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0_2025-11-23_%D0%B2_22.16.40.png',
    fullWidth: true
  }, {
    title: 'Экзистенциальная психотерапия',
    institution: 'Программа GLE International, НИУ ВШЭ',
    year: '2021',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mk9xBFEGMxxM423p2CiQMP/certificate_cropped.png',
    fullWidth: true
  }, {
    title: 'Когнитивно-поведенческая психотерапия',
    institution: 'Московский институт психоанализа',
    year: '2022',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7igHQAH3EZZbQJ2CaCqocT/%D0%A3%D0%B4%D0%BE%D1%81%D1%82%D0%BE%D0%B2%D0%B5%D1%80%D0%B5%D0%BD%D0%B8%D0%B5_%D0%9A%D0%9F%D0%A2.png',
    fullWidth: true
  }, {
    title: 'Терапия пар',
    institution: 'Высшая школа экзистенциального анализа',
    year: '2024',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/egAi9aBYni3aPUG9PWMVcZ/%D0%A1%D0%B5%D1%80%D1%82%D0%B8%D1%84%D0%B8%D0%BA%D0%B0%D1%82.jpeg.jpg',
    fullWidth: true
  }];
  return <section className="w-full py-16 bg-white relative overflow-hidden" data-id="element-86">
      <div className="w-full" data-id="element-87">
        <div className="text-center mb-12 space-y-3 px-6 md:px-10" data-id="element-88">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-89">
            То, на чём основана моя практика
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto" data-id="element-90">
            Мой путь профессионального развития
          </p>
        </div>
        <div className="relative px-6 md:px-10" data-id="element-91">
          <button onClick={() => scroll('left')} className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center hover:bg-gray-50 hover:border-[#3d8f5a] transition-all shadow-lg" aria-label="Previous diplomas" data-id="element-92">
            <ChevronLeftIcon className="w-6 h-6 text-gray-700" data-id="element-93" />
          </button>
          <button onClick={() => scroll('right')} className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center hover:bg-gray-50 hover:border-[#3d8f5a] transition-all shadow-lg" aria-label="Next diplomas" data-id="element-94">
            <ChevronRightIcon className="w-6 h-6 text-gray-700" data-id="element-95" />
          </button>
          <div ref={scrollRef} className="flex gap-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory pb-6 pl-12 pr-12" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-96">
            {diplomas.map((diploma, index) => <div key={index} className="flex-shrink-0 w-[85%] sm:w-[340px] snap-center" data-id="element-97">
                <div className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:scale-[1.02] group h-[580px] flex flex-col" data-id="element-98">
                  <div className="relative overflow-hidden bg-white h-[360px] flex-shrink-0" data-id="element-99">
                    <img src={diploma.image} alt={`Диплом: ${diploma.title}`} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300 p-4" data-id="element-100" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-101" />
                  </div>
                  <div className="p-5 space-y-1.5 flex-1 flex flex-col" data-id="element-102">
                    <h3 className="text-lg font-bold text-gray-900 line-clamp-2" data-id="element-103">
                      {diploma.title}
                    </h3>
                    {diploma.institution && <p className="text-gray-600 text-sm leading-snug line-clamp-3 flex-1" data-id="element-104">
                        {diploma.institution}
                      </p>}
                    <div className="flex items-center gap-2 pt-1" data-id="element-105">
                      <div className="w-2 h-2 rounded-full bg-[#3d8f5a]" data-id="element-106" />
                      <p className="text-sm font-semibold text-[#3d8f5a]" data-id="element-107">
                        {diploma.year}
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#4a9d63] rounded-full opacity-5 blur-3xl pointer-events-none" data-id="element-108" />
    </section>;
};